import apiClient from './client';

// Social Media API
export const socialAPI = {
  // Post to social media
  postToSocial: (data) => apiClient.post('/social/post', data),
  
  // Schedule post
  schedulePost: (data) => apiClient.post('/social/schedule', data),
  
  // Get post history
  getPostHistory: (params) => apiClient.get('/social/posts/history', { params }),
  
  // Get scheduled posts
  getScheduledPosts: (params) => apiClient.get('/social/scheduled', { params }),
  
  // Cancel scheduled post
  cancelScheduledPost: (postId) => apiClient.delete(`/social/scheduled/${postId}`),
  
  // Get platform status
  getPlatformStatus: () => apiClient.get('/social/platforms/status'),
};

export default socialAPI;
